<template>
    <div class="panel round-corner" @click="$emit('btnDetailClick', btnArr[0])">
        <div class="img-wrap">
            <van-image width="48" height="48" lazy-load round fit="cover" :src="complete(img)" />
        </div>

        <div class="content-wrap">
            <h4 class="title max-two-line ht-text-primary">{{ title }}</h4>

            <div class="tag-flex">
                <div class="tag-wrap">
                    <template v-if="tagArr">
                        <van-tag v-for="(item, index) in tagArr" :key="index" :color="item.color">
                            {{ item.text }}
                        </van-tag>
                    </template>
                    <template v-if="item && item.read">
                        <van-tag
                            type="success"
                            style="margin: 0 10px; background: #04be02"
                            v-if="item.read == ' '"
                        ></van-tag>
                        <van-tag
                            type="success"
                            style="margin: 0 10px; background: #04be02"
                            v-else-if="item.read == '0'"
                        >
                            待阅
                        </van-tag>
                        <van-tag v-else style="margin: 0 10px">已阅</van-tag>
                    </template>
                </div>
                <template v-if="todoStatus == 'todo' || todoStatus == 'done'">
                    <van-tag v-if="item.mobPrintFlag == '0' || item.mobPrintFlag == ''" type="success">
                       未导出
                    </van-tag>
                    <van-tag v-else-if="item.mobPrintFlag == '1'">已导出</van-tag>
                </template>
            </div>

            <div class="desc-wrap" :class="{ 'desc-wrap-folded': folded }" v-if="descArr">
                <p class="desc ht-text-assist van-ellipsis" v-for="(item, index) in descArr" :key="index">
                    <span class="key" v-if="item.key">{{ item.key }}：</span>

                    <a class="value ht-text-link" v-if="item.link" :href="item.link">{{ item.value }}</a>
                    <span class="value" v-else>{{ item.value }}</span>
                </p>
            </div>
            <div class="arrow-wrap" @click.stop="folded = !folded" v-if="showFolder">
                <van-icon :name="folded ? 'arrow-down' : 'arrow-up'" color="#999" />
            </div>

            <div class="btn-wrap" v-if="btnArr">
                <van-button
                    class="ht-text-assist ht-text-none-select"
                    plain
                    type="info"
                    size="mini"
                    v-for="(item, index) in btnArr"
                    :key="index"
                    @click.stop="$emit(item.event, item)"
                >
                    {{ item.text }}
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Image, Tag, Button, Icon } from "vant"
    import { locationTo, complete } from "@/utils/url"
    export default {
        name: "Panel",
        components: {
            [Image.name]: Image,
            [Tag.name]: Tag,
            [Button.name]: Button,
            [Icon.name]: Icon,
        },
        props: ["img", "item", "title", "descArr", "btnArr", "tagArr", "foldDesc"],
        data() {
            return {
                folded: false,
                todoStatus: '',
            }
        },
        computed: {
            showFolder() {
                return this.foldDesc && this.descArr && this.descArr.length > 5
            },
        },
        created() {
            if (this.showFolder) this.folded = true
            //获取url地址
            let url = window.location.href
            //判断url中是否包含todo
            if (url.indexOf('todo') != -1) {
                this.todoStatus = 'todo'
                this.item.todo = 'todo'
            } else if (url.indexOf('done') != -1) {
                this.todoStatus = 'done'
            } 
            // else if (url.indexOf('copy') != -1) {
            //     this.item.copy = 'copy'
            // }
            
           
            
            
           
        },
        methods: {
            complete,
        },
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/css/theme/theme.scss";
    .panel {
        position: relative;
        background-color: #ffffff;
        padding: 15px 10px;
        display: flex;
        margin-bottom: 10px;

        .img-wrap {
            margin-right: 10px;
            flex-shrink: 0;
        }

        .content-wrap {
            flex-grow: 1;
            width: 0;

            .title {
                @extend .font14;
            }
            .max-two-line {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .tag-flex {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                .tag-wrap {
                    margin-bottom: 10px;
                }
                .exportInfo {
                    color: #fff;
                    font-size: 12px;
                    font-weight: 400;
                    background: rgb(4, 190, 2);
                }
            }

            .desc-wrap {
                height: auto;
                overflow: hidden;

                &.desc-wrap-folded {
                    height: 100px;
                }
                .ht-text-assist {
                    line-height: 20px;
                    font-weight: 400;
                    color: #8c8c8c;
                    @extend .font12;
                }
            }

            .arrow-wrap {
                text-align: center;
                padding: 3px 0;
                border-radius: 2px;

                &:active {
                    background-color: lighten(#000, 96%);
                }
            }

            .btn-wrap {
                text-align: right;

                button {
                    line-height: 1;
                    border: none;
                    padding: 5px 7px;
                    @extend .font12;
                }

                .van-icon {
                    height: 22px;
                    line-height: 22px;
                }
            }
        }
    }
</style>
